









import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "LoadingContainer",
  props: {
    minWidth: {
      type: Number,
      default: 52
    },
    minHeight: {
      type: Number,
      default: 52
    }
  }
});
